module.exports = __webpack_public_path__ + "af60106fba7bf4ab3f2d0221cf8cd224.png";